export const PAGE_LOGIN = 'pg_login';
export const PAGE_HOME = 'pg_home';
export const NOT_FOUND = 'pg_notFound';
export const DASHBOARD = 'md_dashboard_GLOBAL';
export const CHECKLISTS = 'md_checklists';
export const REPORTS = 'md_reports';
export const QUESTIONNAIRE_BUILDER = 'md_questionnaire_BUILDER';